module.exports = __webpack_public_path__ + "static/media/hb_logo.e0ba3951.png";